import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import { UserService } from '@forwardflow/services/UserService'
import useSWR from 'swr'

export const useGetUserDetailsByEmail = (email: string) => {
   const response = useSWR([QUERY_KEYS.USER_DETAILS_BY_EMAIL, email], () =>
      UserService.getUserDetailsByEmail(email)
   )
   return {
      ...response,
   }
}
